import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import FaqItem from './FaqItem';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import heroImg from '../../images/help_support_v2.jpg';

const bgStyle = {
  backgroundImage: `url(${heroImg})`,
};

import {
  fetchFaqs,
} from '../../actions/faq';

import {
  clearApiError,
} from '../../actions/api';

import {
  SITE_TITLE,
} from '../../constants';

class Help extends Component {

  constructor(props) {
    super(props);
    this.initData = this.initData.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    if(this.props.faqs.length < 1) {
      this.initData();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchFaqs } = this.props;
    await fetchFaqs();
  }

  render() {
    const { loading, error, faqs, t } = this.props;
    if(error) {
      return (
        <ErrorDisplay error={error} />
      );
    }
    if(loading) {
      return (
        <LottieLoader />
      );
    }
    return (
      <>
        <Helmet>
          <title>{t('support:faqTitle')} | { SITE_TITLE }</title>
        </Helmet>
        <div className="fe-hero-container fe-under-header-effect-except-mobile">
          <div className="fe-hero-img" style={bgStyle} />
        </div>
        <article className="fe-help">
          <div className="container">
            <div className="row justify-content-lg-center">
              <div className="col-lg-10">
                <section className="fe-help-support">
                  <h1 className="fe-heading">{t('support:faqTitle')}</h1>
                  <p>{t('support:faqText')}</p>
                  <div className="fe-help-faq">
                    {faqs.map((faq, idx) => (
                      <FaqItem
                        key={idx}
                        category={faq.category}
                        faqs={faq.faqs}
                        icon={faq.icon}
                      />
                    ))}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </article>
      </>
    );
  }
}

Help.propTypes = {
  faqs: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  fetchFaqs: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ faqState, apiState }) => ({
  faqs: faqState.faqs,
  loading: faqState.loading,
  error: apiState.error,
});

const mapDispatchToProps = {
  fetchFaqs,
  clearApiError,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Help));
